
import { Component, Prop, Vue } from 'vue-property-decorator';
import BoxError from '@/components/box/BoxError/BoxError.vue';
import store from '@/store';

// @ is an alias to /src
@Component({
  components: {
    BoxError
  }
})
export default class Error extends Vue {
  @Prop({ type: Number, required: false })
  readonly status!: number | undefined

  goBack() {
    if (window.history.length > 1) {
      this.$router.go(-1)
    } else {
      this.$router.push({ name: 'home' }) // デフォルトの遷移先
    }
  }

  private mounted() {
    store.commit('loaded', true);
  }
}
